import { httpRequest, isNetworkError } from '@app/httpRequest.js';
import type { Processor } from '@app/store/middleware/processorMiddleware.js';
import { toastsAdd } from '@features/toasts/model/actions.js';
import { trackMatomo } from '@shared/trackMatomo.js';
import { loadAuthMessages } from '../../translations/loadAuthMessages.js';
import { authLogout, authStartLogout } from '../actions.js';

export const authLogoutProcessor: Processor = {
  actionCreator: authStartLogout,
  async handle({ dispatch, getState, toastError }) {
    try {
      trackMatomo(['trackEvent', 'Auth', 'logout']);

      try {
        FB.logout();
      } catch {
        // ignore
      }

      await httpRequest({
        getState,
        method: 'post',
        url: '/auth/logout',
        expectedStatus: [204, 401],
      });

      dispatch(authLogout());

      dispatch(
        toastsAdd({
          id: 'lcd',
          messageKey: 'logOutSuccess',
          messageLoader: loadAuthMessages,
          style: 'info',
          timeout: 5000,
        }),
      );
    } catch (err) {
      // A request that never reached the server still ends the session here:
      // staying logged in is not what the user asked for, and the cookie the
      // server keeps is replaced by the next log-in.
      if (isNetworkError(err)) {
        dispatch(authLogout());

        return;
      }

      await toastError(err, loadAuthMessages, 'logOutError', 'lcd');
    }
  },
};
